import {Store, Module, ActionContext} from 'vuex';
import ListModule from '../list-module';
import ListState from '../list-state';
import Wallet from '@/store/entities/finance/Wallet';
import Ajax from '@/lib/ajaxFinance';
import Util from '@/lib/util'

interface WalletState extends ListState<Wallet>{
    editWallet: Wallet;
}

class WalletModule extends ListModule<WalletState, any, Wallet>{
    state={
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Wallet>(),
        loading: false,
        editWallet: new Wallet(),
    }
    actions={
        async getByUser(context: ActionContext<WalletState, any>, payload: any){
            let reponse = await Ajax.get('/Wallet/getByUser?userNo=' + payload.data.userNo + '&userName=' + Util.abp.session.getPhoneNumberCookie());
            context.state.editWallet = reponse.data.result as Wallet; // set value for editing.
            return reponse.data.result as Wallet;
        },
        async pay(context: ActionContext<WalletState, any>, payload: any){
            let reponse = await Ajax.post('/Wallet/pay', payload.data);
            return reponse.data;
        },
    };
    mutations={
        setCurrentPage(state: WalletState, page: number){
            state.currentPage = page;
        },
        setPageSize(state: WalletState, pagesize: number){
            state.pageSize = pagesize;
        }
    }
}
const walletModule = new WalletModule();
export default walletModule;